<template>
  <Head title="Admin - Initiative Editor" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <initiative-editor :initiative_types="initiative_types"></initiative-editor>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  initiative_types: Array
});
</script>

